module.exports = __webpack_public_path__ + "img/EASTASIA_WHOLE_GRAINS.fbaa88fe.png";